export function handleAspectRatio(aspectRatio: string, k: number) {
	if (aspectRatio) {
		switch (aspectRatio) {
			case "1/1":
				return "6";
			case "2/1":
				return k % 2 === 0 ? "8" : "4";
			case "3/1":
				return k % 2 === 0 ? "9" : "3";
			case "5/1":
				return k % 2 === 0 ? "10" : "2";
			case "1/2":
				return k % 2 === 0 ? "4" : "8";
			case "1/3":
				return k % 2 === 0 ? "3" : "9";
			case "1/5":
				return k % 2 === 0 ? "2" : "10";
			case "7/5":
				return k % 2 === 0 ? "7" : "5";
			case "5/7":
				return k % 2 === 0 ? "5" : "7";
			default:
				return "";
		}
	}

	return "";
}
